import { CookieConsent } from './CookieConsent';
import { AppMetaTags } from './AppMetaTags';
import { AndroidSmartBanner } from './AndroidSmartBanner';
import { SupportWidget } from './SupportWidget';
import { useAppData } from '@/contexts/AppDataContext';

interface AppWrapperProps {
  children: React.ReactNode;
}

export const AppWrapper = ({ children }: AppWrapperProps) => {
  const { config } = useAppData();

  return (
    <>
      <AppMetaTags />
      <AndroidSmartBanner />
      <SupportWidget />
      <main id="main-content" role="main">
        {children}
      </main>
      <CookieConsent config={config} />
    </>
  );
};
